<template>
  <div class="head">
    <div class="box_01">
      <div class="item">
        <img :src="imgList.list_06[5]" alt="" />
      </div>
      <div class="item_home" @click="GoOtherPage('home')">中昆首页</div>
    </div>
    <div class="box_02">
      <div class="box_02_01">
        <div class="item">专注于昆虫繁育、标本加工、展馆规划设计施工</div>
      </div>
      <div class="box_02_02">
        <div class="item" @click="GoOtherPage('InsectSpecimen')">昆虫标本</div>
        <div class="item" @click="GoOtherPage('MuseumDesign')">
          展馆设计施工
        </div>
        <div class="item" @click="GoOtherPage('ScienceResearch')">科普研学</div>
        <div class="item" @click="GoOtherPage('InsectBreed')">昆虫繁育</div>
        <div class="item" @click="GoOtherPage('InsectCraft')">展品礼品定制</div>
        <div class="item" @click="GoOtherPage('昆虫图鉴')">昆虫图鉴</div>
        <div class="item" @click="GoOtherPage('后台管理')">后台管理</div>
      </div>
    </div>
    <div class="box_03">
      <img :src="data.imgList.phone" alt="" />
    </div>
  </div>
  <div class="mobile">
    <div class="mobile_head">
      <div class="imgBox">
        <img class="img_01" :src="imgList.list_06[5]" alt="" />
        <img class="img_01" :src="imgList.list_06[6]" alt="" />
      </div>
      <div class="text">专注于昆虫繁育、标本加工、展馆规划设计施工</div>
    </div>
    <div class="bottom_bar">
      <div class="iconBox" @click="GoOtherPage('home')">
        <img :src="imgList.icon[4]" alt="" />
        <div>首页</div>
      </div>
      <div class="iconBox" @click="GoOtherPage('InsectSpecimen')">
        <img :src="imgList.icon[5]" alt="" />
        <div>生物标本</div>
      </div>
      <div class="iconBox" @click="GoOtherPage('MuseumDesign')">
        <img :src="imgList.icon[6]" alt="" />
        <div>展馆设计</div>
      </div>
      <div class="iconBox" @click="GoOtherPage('ScienceResearch')">
        <img :src="imgList.icon[7]" alt="" />
        <div>科普研学</div>
      </div>
      <div class="iconBox" @click="GoOtherPage('InsectCraft')">
        <img :src="imgList.icon[8]" alt="" />
        <div>展品定制</div>
      </div>
    </div>
  </div>

  <div class="con">
    <router-view />
    <div class="mobileContact">
      <ContactMobile />
    </div>
  </div>
  <!-- <img
    class="test"
    :src="
      'https://zhongkun-1306785868.cos-website.ap-shanghai.myqcloud.com/img/' +
      data.data
    "
    alt
  /> -->
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import imgList from "@/myJs/imgList";
import ContactMobile from "./views/ContactMobile.vue";
import api from "@/api/index";
import axios from "axios";
export default {
  components: {
    ContactMobile,
  },
  setup() {
    const router = new useRouter();
    let data = reactive({
      imgList: {
        phone: require("@/assets/phone.jpg"),
      },
      data: "",
    });

    onMounted(() => {
      GoOtherPage("home");
      GetData();
    });

    const GetData = () => {
      let data_01 = {
        id: 81807,
        command: "selectById",
      };
      axios({
        method: "get",
        url: api.host + api.selectUniversal,
        params: data_01,
      }).then((res) => {
        data.data = res.data.results[0].para_10;
      });
    };

    const GoOtherPage = (name) => {
      let url;
      if (name == "昆虫图鉴") {
        // url = "http://www.196116.com:4001";
        url = "http://111.229.10.74:4001";
        window.open(url, "_blank");
      } else if (name == "后台管理") {
        url = "http://111.229.10.74:4000";
        window.open(url, "_blank");
      } else {
        router.push({
          name: name,
        });
      }
    };

    return {
      data,
      GoOtherPage,
      imgList,
      ContactMobile,
      GetData,
    };
  },
};
</script>

<style lang="less">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  text-align: center;
}
.test {
  width: 100px;
}
// 手机版
.mobileContact {
  @media only screen and (min-width: 800px) {
    display: none;
  }
}
.mobile {
  @media only screen and (min-width: 800px) {
    display: none;
  }
  .mobile_head {
    position: fixed;
    top: 0;
    width: 100vw;
    height: 10vh;
    box-shadow: 0 0 2px 2px rgb(200, 200, 200);
    .text {
      color: gray;
      font-size: 1rem;
      padding: 1vw 0 0 0;
      font-family: 隶书;
    }
    .imgBox {
      width: 100vw;
      display: flex;
      justify-content: space-around;
      .img_01 {
        padding: 2vw 0 0 0;
        height: 6vh;
        object-fit: contain;
      }
    }
  }
  .bottom_bar {
    position: fixed;
    top: 90vh;
    width: 100vw;
    height: 10vh;
    // border: 1px solid red;
    left: 0;
    z-index: 99;
    background-color: rgb(255, 255, 255);
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-shadow: 0 0 2px 2px rgb(200, 200, 200);
    .iconBox {
      width: 15vw;
      height: 15vw;
      // border: 1px solid red;
      font-size: 0.8rem;
      text-align: center;
      img {
        width: 8vw;
        object-fit: contain;
      }
    }
  }
}
.head {
  position: fixed;
  top: 0;
  height: 80px;
  left: 0;
  width: 100%;
  background-color: rgb(228, 0, 130);
  display: flex;
  padding: 0;
  z-index: 99;
  @media only screen and (max-width: 800px) {
    display: none;
  }
  .box_01 {
    flex: 1;
    height: 90%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    .item {
      width: 100px;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .item_home {
      font-size: 18px;
      font-family: 黑体;
      font-weight: bold;
      background-color: rgb(220, 220, 220);
      color: rgb(65, 105, 138);
      border-radius: 20px;
      padding: 5px 20px;
      margin: 0 20px;
    }
  }
  .box_02 {
    flex: 3;
    height: 90%;
    background-color: white;
    // border: 1px solid red;
    .box_02_01 {
      background-color: rgb(255, 255, 255);
      height: 65%;
      display: flex;
      justify-content: space-around;
      font-family: 楷体;
      .item {
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 28px;
      }
    }
    .box_02_02 {
      display: flex;
      justify-content: space-around;
      font-family: 黑体;
      height: 35%;
      .item {
        height: 100%;
        display: flex;
        align-items: center;
        padding: 0 30px;
        border-radius: 5px;
      }
      .item:hover {
        background-color: rgb(220, 220, 220);
      }
    }
  }
  .box_03 {
    flex: 1;
    height: 90%;
    background-color: white;
    align-items: center;
    display: flex;
    justify-content: center;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
.con {
  padding: 80px 0 0 0;
  @media only screen and (max-width: 800px) {
    position: fixed;
    width: 100vw;
    height: 80vh;
    top: 10vh;
    left: 0;
    padding: 0;
    overflow: scroll;
  }
}
</style>
